import styles from "./styles.module.scss";
import { useContext, useState } from "react";
import { useLocation } from "react-router-dom";

import { PopconfirmProps } from "./types";
import { MergedColumnType } from "../table/utils/types";
import { TranslationContext } from "../../../contexts/translation/index.context";
import { ModalContext } from "../../../contexts/modal/index.context";
import { SessionContext } from "../../../contexts/session/index.context";
import { request } from "../../../services";
import { DatepickerContext } from "../../../contexts/datepicker/index.context";

//UI
import Button from "antd/lib/button";
import Popconfirm from "antd/lib/popconfirm";
import message from "antd/lib/message";
import Tooltip from "antd/lib/tooltip";

//Icons
import DeleteOutlined from "@ant-design/icons/DeleteOutlined";
// import checkIsAdmin from '../../../helpers/checkIsAdmin';
import checkBefore from '../../../helpers/selectionOfActions';

// Компонент кнопки видалення та опрацювання логіки

export default function PopconfirmComponent(props: PopconfirmProps) {

  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { disabled, setDisabled, setRefresh } = useContext(ModalContext);
  const { intl } = useContext(TranslationContext);
  const { sessionData } = useContext(SessionContext);
  // console.log("PopconfirmComponent sessionData ", sessionData);
  const location = useLocation();
  // console.log("URL PopconfirmComponent location ", location);
  const url = props.url || location.pathname;
  const isIncomingEmail = url === "/directories/incoming-email";
  const usingEmailData = isIncomingEmail && JSON.parse(
      sessionStorage.getItem("electronic_mail_data") || "null"
    )?.selectedEmail;

  const showPopconfirm = () => {
    // setOpen(true);
  };


// const checkBefore = async (prop?: string) => {
//   console.log('props.name: ', props.name);
//   console.log('propURL: ', prop);
//   console.log('props.url: ', location.pathname);

//   const propsUrl = location.pathname;
//   const urlKey = prop ?? propsUrl;

//   let permissionKey: string;

//   switch (urlKey) {
//     case '/directories/passing':
//       permissionKey = 'del_passing';
//       break;
//     case '/directories/related-documents':
//       permissionKey = 'del_related';
//       break;
//     default:
//       permissionKey = 'del';
//       break;
//   }

//   if (!permissionKey) return false;

//   const isAdm = await checkIsAdmin(propsUrl, permissionKey);

//   if (isAdm) {
//     message.error(intl('you-do-not-have-access-rights'));
//   }

//   return isAdm;
// };

  // const [popVisible, setPopVisible] = useState(false);


  const handleOk = async () => {
  // console.log('propss.url: ', props.name);

    // console.log("request delete QUERY", {
    //   id: sessionData?.id,
    //   documentId: sessionData?.bta_documents_id,
    //   page: url?.split("/").pop(),
    //   ...(isIncomingEmail ? { email: usingEmailData } : {}),
    //   url,
    // });
    const replacePropsName = props.name ? props.name : 'remove';

    let accessRights = await checkBefore(location.pathname, props.url, replacePropsName);
    if (!accessRights) {
      message.error(intl("you-do-not-have-access-rights"));
      return;
    }

    setLoading(true);
    const success = (
      await request(`${url}/deletedatatable`, {
        method: "post",
        body: {
          id: sessionData?.id,
          documentId: sessionData?.bta_documents_id ?? sessionData?.bta_document_id,
          page: url?.split("/").pop(),
          ...(isIncomingEmail ? { email: usingEmailData } : {}),
          url,
        },
        cancelTokenKey: "deletedatatable",
      })
    )?.success;
    if (!success) {
      message.error(intl("data-is-not-deleted"));
    } else {
      setRefresh(true);
      sessionStorage.removeItem("row_data");
      const currentTableState = JSON.parse(
        sessionStorage.getItem("table_state") || "null"
      );
      sessionStorage.setItem(
        "table_state",
        JSON.stringify({
          ...currentTableState,
          selectedRow: undefined,
        })
      );
      // console.log("url PopconfirmComponent: ", url);
      url === "/profile/menu-tabs" &&
        message.info(
          intl(
            "changes-will-take-effect-only-after-the-user-re-authorizes-the-system"
          )
        );
      setDisabled({ ...disabled, edit: true });
    }
    setLoading(false);
  };

  // const handleCancel = () => {
  //   setOpen(false);
  //   // setPopVisible(false)
  // };

      //Компонент перевірка на доступ до внесення даних чи змін

  //   const handleDeleteClick = async () => {
  //   const { isAdm } = await checkIsAdmin(location.pathname, 'del');
  //   if (!isAdm) {
  //     message.error(intl("you-do-not-have-access-rights"));
  //     return;
  //   }
  //   setPopVisible(true);
  // };

  // Виніс кнопку окремо від Popconfirm для реалізації перевірки на доступ

  // Компонент кнопки видалення в таблиці

  return (
    <Popconfirm
      title={sessionData?.parent_route ? intl("question-delete-entry-tab"): intl("question-delete-entry") }
      onConfirm={handleOk}
      // onCancel={handleCancel}
      okButtonProps={{ loading, className: styles["popconfirm"] }}
      okText={intl("ok")}
    >
          <Tooltip title={intl(`remove`)}>       

     <Button
        // className={`${styles["button"]} ${
        //   !disabled.edit && styles["custom-button"]
        // }`}
        className={styles["button"]}
        disabled={disabled.edit}
        icon={<DeleteOutlined />}
        // onClick={handleDeleteClick}
    >
        {props.name ? intl(props.name || "remove") : ""}
    </Button>
          </Tooltip>

    </Popconfirm>
  );
}
